import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

interface SubmittedDialogProps {
  open: boolean;
  onClose: () => void;
  showScore?: boolean;
}

export default function SubmittedDialog({ open, onClose, showScore = false }: SubmittedDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="submitted-dialog-title"
      aria-describedby="submitted-dialog-description"
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          overflow: 'visible'
        }
      }}
    >
      <DialogTitle id="submitted-dialog-title" sx={{ fontWeight: 'bold' }}>
        Assessment Submitted
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="submitted-dialog-description"
          sx={{
            color: 'text.secondary',
            fontSize: '0.95rem',
            lineHeight: 1.6,
          }}
        >
          {showScore 
            ? "Your assessment has been submitted, your score will be emailed to you"
            : "Your assessment has been submitted"
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "#10b981",
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1,
            boxShadow: '0 4px 12px -2px rgba(16, 185, 129, 0.3)',
            '&:hover': {
              backgroundColor: "#059669",
              boxShadow: '0 8px 20px -4px rgba(16, 185, 129, 0.4)',
              transform: 'translateY(-1px)'
            },
            transition: 'all 0.2s ease'
          }}
        >
          Back Home
        </Button>
      </DialogActions>
    </Dialog>
  );
}